import {v4 as uuidv4} from 'uuid';
import starterArt from '@blocks-shared/starter-art.json';
import type {BlocksCostume} from './projectTypes.ts';

/*
 * Built-in starter sprites: simple flat SVG characters shipped as data URLs,
 * so projects stay self-contained (no storage assets to copy on remix).
 * Most characters have two poses — "next costume" animates them.
 *
 * The art lives in MixiplyCore/Scene/DefaultTemplates/starter-art.json, shared
 * with the server so AI agents can add the same characters by key.
 */

export interface StarterCharacter {
    key: string;
    label: string;
    // Data URLs, one per costume/pose.
    frames: string[];
    // The costume names, matching frames.
    costumeNames: string[];
}

interface StarterArtFile {
    characters: {
        key: string;
        label: string;
        costumes: {name: string; url: string}[];
    }[];
}

export const STARTER_CHARACTERS: StarterCharacter[] = (
    starterArt as StarterArtFile
).characters.map(character => ({
    key: character.key,
    label: character.label,
    frames: character.costumes.map(costume => costume.url),
    costumeNames: character.costumes.map(costume => costume.name)
}));

export function createStarterCostumes(
    character: StarterCharacter
): BlocksCostume[] {
    return character.frames.map((url, index) => ({
        id: uuidv4(),
        name: character.costumeNames[index] ?? `${character.key}-${index + 1}`,
        type: 'image' as const,
        url
    }));
}
